import React from 'react';

export default function SpikedCollarSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Collar band */}
      <path d="M6 20C6 20 10 26 20 26C30 26 34 20 34 20" stroke="#1A1A1A" strokeWidth="5" strokeLinecap="round" fill="none" />
      {/* Collar inner */}
      <path d="M8 20C8 20 12 25 20 25C28 25 32 20 32 20" stroke="#2C2419" strokeWidth="3" strokeLinecap="round" fill="none" />
      {/* Spikes */}
      <path d="M10 19L11 13L12 19" fill="#C0C0C0" />
      <path d="M14 21L15 15L16 21" fill="#C0C0C0" />
      <path d="M18 22L19 16L20 22" fill="#C0C0C0" />
      <path d="M22 22L23 16L24 22" fill="#C0C0C0" />
      <path d="M26 21L27 15L28 21" fill="#C0C0C0" />
      <path d="M30 19L31 13L32 19" fill="#C0C0C0" />
      {/* Spike highlights */}
      <line x1="11" y1="14" x2="11" y2="17" stroke="#E0E0E0" strokeWidth="0.5" />
      <line x1="15" y1="16" x2="15" y2="19" stroke="#E0E0E0" strokeWidth="0.5" />
      <line x1="19" y1="17" x2="19" y2="20" stroke="#E0E0E0" strokeWidth="0.5" />
      <line x1="23" y1="17" x2="23" y2="20" stroke="#E0E0E0" strokeWidth="0.5" />
      <line x1="27" y1="16" x2="27" y2="19" stroke="#E0E0E0" strokeWidth="0.5" />
      <line x1="31" y1="14" x2="31" y2="17" stroke="#E0E0E0" strokeWidth="0.5" />
      {/* Buckle */}
      <rect x="18" y="24" width="4" height="3" rx="0.5" fill="#C0C0C0" stroke="#A0A0A0" strokeWidth="0.5" />
    </svg>
  );
}
